module.exports = __webpack_public_path__ + "static/img/img6.22302cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img6.png
// module id = ziZL
// module chunks = 1